import React, { useContext, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { useThrottle } from '@wix/da-hooks/pkg/useThrottle';
import { useResizeObserver } from '@wix/da-hooks/pkg/useResizeObserver';
import { BiData, BiContextProvidedValue, } from '@wix/da-bi/pkg/events';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { default as AddCircleIcon } from '@wix/da-ds/pkg/Icons/AddCircle';
import IconButton from '../../../Button/IconButton';
import { useIsCommentEditorSubmittable } from '../../../CommentEditor/hooks/useIsCommentEditorSubmittable';
import { CommentEditorSource } from '../../../CommentEditor/redux/types';
import { CommentEditorContext, EditorContext, } from '../../../CommentEditor/context';
import { StickyCommentBoxContext } from '../../presets/StickyCommentBox/context';
import s from './CommentBoxFooter.scss';
var RESIZE_THROTTLE_DELAY = 300;
var RESIZE_THROTTLE_OPTIONS = { trailing: true };
var COLLAPSE_BREAKPOINT_WIDTH = 440;
/**
 * The footer for our CommentBox editor.
 *
 * TODO: Refactor this more. There is room for this to be modularized.
 */
var CommentBoxFooter = function (_a) {
    var onCancel = _a.onCancel, onPost = _a.onPost, className = _a.className;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var isStuck = useContext(StickyCommentBoxContext);
    var _b = useContext(CommentEditorContext), isBusy = _b.isBusy, isEditorExpanded = _b.isExpanded, shouldUseFallback = _b.shouldUseFallback, isFallbackEmpty = _b.isFallbackEmpty, editorSource = _b.editorSource;
    var isSubmittable = useIsCommentEditorSubmittable();
    var toolbars = useContext(EditorContext).toolbars;
    var Toolbar = toolbars === null || toolbars === void 0 ? void 0 : toolbars.INSERT_PLUGIN;
    var isEdit = editorSource === CommentEditorSource.Edit;
    var _c = useState(isMobile), isToolbarCollapsable = _c[0], setIsToolbarCollapsable = _c[1];
    var _d = useState(false), isToolbarExpanded = _d[0], setIsToolbarExpanded = _d[1];
    var rootRef = useRef(null);
    var _e = useState(0), rootWidth = _e[0], setRootWidth = _e[1];
    var handleResize = useThrottle(function () {
        if (isMobile) {
            return;
        }
        var newWidth = rootRef.current.clientWidth;
        if (newWidth !== rootWidth) {
            setRootWidth(newWidth);
            setIsToolbarCollapsable(newWidth < COLLAPSE_BREAKPOINT_WIDTH);
        }
    }, [rootWidth, isMobile], RESIZE_THROTTLE_DELAY, RESIZE_THROTTLE_OPTIONS);
    useResizeObserver(rootRef, handleResize);
    var handleToolbarClick = function (ev) {
        setIsToolbarExpanded(false);
    };
    return (React.createElement("footer", { className: classnames(s['root'], (isEditorExpanded || shouldUseFallback) && s['editor-expanded'], isToolbarCollapsable && s['collapsable-toolbar'], isToolbarExpanded && s['expanded-toolbar'], className), ref: rootRef },
        React.createElement("div", { className: s['toolbar-wrapper'] }, !shouldUseFallback && Toolbar && (React.createElement(React.Fragment, null,
            React.createElement(IconButton, { className: s['toolbar-toggle'], onClick: function () { return setIsToolbarExpanded(!isToolbarExpanded); }, "aria-label": t('commentbox.a11y.button.expandToolbar') },
                React.createElement(AddCircleIcon, { size: IconSize.MEDIUM })),
            React.createElement("div", { className: s['toolbar'], onClick: handleToolbarClick },
                React.createElement(Toolbar, { className: s['editor-toolbar'] }))))),
        React.createElement("div", { className: s['right'] },
            React.createElement(TextButton, { variant: "main", size: "small", disabled: isBusy || (shouldUseFallback && isFallbackEmpty), onClick: onCancel, biData: BiData({
                    evid: 189,
                    itemid: BiContextProvidedValue,
                    typeid: BiContextProvidedValue,
                    is_comment_thread: BiContextProvidedValue,
                    is_sticky: isStuck ? 1 : 0,
                }) }, t('commentbox.button.cancel')),
            React.createElement(TextButton, { variant: "approval-green", size: "medium", disabled: !isSubmittable, onClick: onPost }, isEdit
                ? t('commentbox.button.update')
                : t('commentbox.button.comment')))));
};
export default CommentBoxFooter;
//# sourceMappingURL=CommentBoxFooter.js.map